import React, { Component } from 'react';
import $j from 'jquery';
import { ActivityIndicator, SnackBarHelper } from '@lyearn-team/frontend-components';
import { ExternalScriptsEnum } from 'appConsts/ExternalScriptsEnum';
import { withExternalScript } from 'components/ScriptLoader';
import EventsHelper from './eventsHelper';
import { checkWistiaVideoStatus } from './checkVideoStatus';

const playerOptions = {
  playerColor: '#071A32',
  resumable: false,
  videoFoam: {
    maxHeight: 427.5
  }
};

@withExternalScript({
  src: ExternalScriptsEnum.WistiaPlayer.src,
  id: ExternalScriptsEnum.WistiaPlayer.id
})
class WistiaEmbed extends Component {
  state = {
    videoProcessing: false
  };

  componentDidMount() {
    window._wq = window._wq || [];
    console.log('this.props', JSON.stringify(this.props, null, 2));
    if (this.props.useEventsHelper) {
      this.initEventsHelper(this.props);
    }
    this.initiateVideo(this.props.videoId, false);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.videoId !== this.props.videoId || prevProps.uniqueId !== this.props.uniqueId) {
      const videoUpdated =
        prevProps.videoId !== this.props.videoId && prevProps.uniqueId === this.props.uniqueId;
      this.videoStatusCheckTimeout && clearTimeout(this.videoStatusCheckTimeout);
      this.handle && this.handle.remove();
      this.handle = null;
      if (this.props.useEventsHelper) {
        this.initEventsHelper(this.props);
      }
      console.log('didUPdate:: ', this.props.videoId);
      this.initiateVideo(this.props.videoId, videoUpdated);
    } else if (prevProps.thumbUrl !== this.props.thumbUrl) {
      const elemId = this.props.videoId + (!this.props.editable ? '-preview' : '');
      const thumbUrl =
        !this.props.thumbUrl ||
        this.props.thumbUrl.indexOf('wistiaInit:') === 0 ||
        this.props.thumbUrl ===
          'https://fast.wistia.com/assets/images/zebra/elements/dashed-thumbnail.png'
          ? undefined
          : this.props.thumbUrl;
      if (!this.handle) {
        window.analytics.track('WISTIA_PLAYER_INITIALIZATION_ISSUE', {
          url: window.location.href,
          prevProps: JSON.stringify(prevProps),
          props: JSON.stringify(this.props)
        });
        SnackBarHelper.showSnackbar({
          label: 'Some error occured, please try again.',
          duration: 7,
          status: 'error'
        });
      } else {
        this.handle.replaceWith(elemId, Object.assign({}, playerOptions, { stillUrl: thumbUrl }));
      }
    }
  }

  componentWillUnmount() {
    // console.log('removing - now');
    this.videoStatusCheckTimeout && clearTimeout(this.videoStatusCheckTimeout);
    this.handle && this.handle.remove();
    this.handle = null;
    this.eventsHelper && this.eventsHelper.destroy();
    this.eventsHelper = null;
    // console.log('removing - DONE');
  }

  initEventsHelper = props => {
    if (props.blockPerformance) {
      this.eventsHelper = new EventsHelper(this, {
        videoId: props.videoId,
        allowSeekAhead:
          props.completionType !== 'SCROLL_BASED' ? true : props.allowSeekAhead || false,
        initialSeekableLength: props.blockPerformance.videoWatchedLength || 0
      });
    }
  };

  initiateVideo = async (videoId, updated) => {
    const self = this;
    let videoStatus = 'ready';
    if (this.props.editable && updated) {
      videoStatus = await checkWistiaVideoStatus(videoId);
      if (videoStatus === 'unknown') {
        // in creator mode and video status is not one of the ENUMS
        this.setState({
          videoProcessing: true
        });
        this.videoStatusCheckTimeout = setTimeout(() => this.initiateVideo(videoId), 6000);
        return;
      }
    }
    this.setState(
      {
        videoProcessing: false
      },
      () => {
        const elemId = videoId + (!this.props.editable ? '-preview' : '');
        if ($j('#' + elemId).length > 0) {
          const thumbUrl =
            !this.props.thumbUrl || this.props.thumbUrl.indexOf('wistiaInit:') === 0
              ? undefined
              : this.props.thumbUrl;
          window._wq.push({
            id: elemId,
            options: Object.assign({}, playerOptions, { stillUrl: thumbUrl }),
            plugins: {
              'captions-v1': {
                language: '',
                onByDefault: 'true',
                on: 'true'
              }
            },
            onReady: video => {
              self.handle = video;
              this.props.videoDurationAvailale &&
                this.props.videoDurationAvailale(video.duration());
              // console.log('self.eventsHelper: ', self.eventsHelper);
              if (this.props.blockPerformance) {
                self.eventsHelper &&
                  self.eventsHelper.updateBlockPerformance(
                    this.handle.duration(),
                    this.props.blockPerformance.videoWatchedLength || 0
                  );
              }
              // console.log(this.handle.duration());
              // For applying locally stored playback rate
              const storedPlaybackRate = localStorage.getItem('wistiaPlayerPlaybackRate');
              if (storedPlaybackRate <= 2 && storedPlaybackRate > 0) {
                this.handle.playbackRate(storedPlaybackRate);
              }
              self.eventsHelper && self.eventsHelper.videoReady();
            }
          });
        }
      }
    );
  };

  componentDidCatch(error, errorInfo) {
    if (errorInfo && errorInfo.componentStack) {
      // The component stack is sometimes useful in development mode
      // In production it can be somewhat obfuscated, so feel free to omit this line.
      console.log(errorInfo.componentStack);
    }

    window.bugsnagClient && window.bugsnagClient.notify(error);
  }

  render() {
    return (
      <div
        key={this.props.videoId}
        className="wistia_responsive_wrapper"
        style={{ height: '100%', left: '0', position: 'absolute', top: '0', width: '100%' }}
      >
        {!this.state.videoProcessing && (
          <div
            id={this.props.videoId + (!this.props.editable ? '-preview' : '')}
            className={`wistia_embed wistia_async_${this.props.videoId}`}
            style={{ height: '100%', width: '100%' }}
          >
            &nbsp;
          </div>
        )}
        {this.state.videoProcessing && (
          <div>
            <div style={{ textAlign: 'center' }}>This video is being processed, please wait</div>
            <div className="mediumActivityLoaderWrapper">
              <ActivityIndicator />
            </div>
          </div>
        )}
      </div>
    );
  }
}

WistiaEmbed.defaultProps = {
  useEventsHelper: true
};

export default WistiaEmbed;
